import { Component} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { TFormState } from '../../../../models/forms.model';
import { DecimalPipe } from '@angular/common';
import { DialogsMTService } from '../../../../services/modal/dialogs-mt.service';
import { catchError, EMPTY, filter, switchMap, tap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'contract-block-bank-products-request-form',
    templateUrl: './contract-block-bank-products-request-form.html',
    styleUrl: './contract-block-bank-products-request-form.scss',
 
})
export class AppContractBlockBankProductsRequestComponent {
    public product:string = ''
    public requestForm: FormGroup;
    public termsForRequest = ['1 месяц', '2 месяца','3 месяца','4 месяца','6 месяцев', '1 год','1,5 года', '3 года']
    public formState:TFormState = 'Default'
    constructor(
      private fb: FormBuilder,
        private decimalPipe: DecimalPipe,
        private translateService: TranslateService,
        private dialogRef:MatDialogRef<AppContractBlockBankProductsRequestComponent>,
        private dialogsMTService:DialogsMTService
    ) { 
      this.requestForm = fb.group({
          total: [null, {validators: [Validators.required,Validators.pattern('[0-9,]*([0-9.]{0,3})?$') ]}],
          term: ['3 месяца', ],
          termManual: [null, ],
      });
    }
    processRequest() {
        let successBody = `Запрос на услугу успешно сформирован и передан в Банк: \n\n` 
        + 'Продукт - ' + this.translateService.instant('CONTRACTS.CARD.PRODUCTS.'+this.product) +' \n'
        +' Сумма - ' + this.decimalPipe.transform(this.total?.value,'1.2-2') + '\n'
        +' Срок - ' + (this.term?.value||this.termManual?.value);

        this.dialogsMTService.confirmDialog({
            actionHeader: 'CONFIRM.HEADERS.ATTENTION',
            actionBody: 'CONTRACTS.TEXT.SHARE_CONTRACT'
        }).pipe(
            tap(res => res.isConfirmed? null: this.dialogRef.close()),
            filter(res => res.isConfirmed),
            switchMap(()=> this.dialogsMTService.setNotification({
                actionHeader: 'CONTRACTS.CARD.ASK_PRODUCT_HEADER',
                actionBody: successBody
            })),
            tap(()=>this.dialogRef.close()),
            catchError(() => {
                return EMPTY
            })
        ).subscribe()
    }
    get total() {return this.requestForm.get('total')  }
    get term() {return this.requestForm.get('term')  }
    get termManual() {return this.requestForm.get('termManual')  }
}